import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const youtubeSlice = createSlice({
  name: 'youtube',
  initialState,
  reducers: {
    youtubeStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        // textColor: itemDesign.textColor ?? '#000000',
        // opacity: itemDesign.opacity ?? 0,
        // size: itemDesign.size ?? 50,
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#000000',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    youtubeClear: () => initialState,

    youtubeUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    youtubeUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    youtubeUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    youtubeUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { youtubeStore, youtubeClear, youtubeUpdateIsLoading, youtubeUpdateIsActive, youtubeUpdateBlockContent, youtubeUpdateBlockDesign } = youtubeSlice.actions;

export const selectYouTubeIsLoading = (state) => state.youtube.isLoading;

export const selectYouTubeId = (state) => state.youtube.id;
export const selectYouTubeUID = (state) => state.youtube.uid;
export const selectYouTubeSID = (state) => state.youtube.sid;

export const selectYouTubeBlockContent = (state) => state.youtube.blockContent;
export const selectYouTubeBlockDesign = (state) => state.youtube.blockDesign;
export const selectYouTubeSortItems = createSelector([selectYouTubeBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectYouTubeItemDesign = (state) => state.youtube.itemDesign;
export const selectYouTubeContainerDesign = (state) => state.youtube.containerDesign;

export default youtubeSlice.reducer;
